import React from "react";
import { ClipboardListIcon } from "lucide-react";
import { CTAButton } from "./CTAButton";
import { Countdown } from "./Countdown";
import { images } from "../data/content";
export function Hero() {
  return <header className="w-full bg-cream px-4 pb-14 pt-6 sm:pt-10" data-id="element-177" data-mp="9lv1krql6hwd">
      <div className="mx-auto flex max-w-5xl flex-col items-center text-center" data-id="element-178" data-mp="4lyw0o28qiep">
        <div className="flex flex-wrap items-center justify-center gap-2" data-id="element-179" data-mp="4jvup7vn12uo">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-navy text-gold" data-id="element-180" data-mp="128pixfs3x15m">
            <ClipboardListIcon className="h-5 w-5" aria-hidden="true" data-id="element-181" data-mp="xb5szim1qzxu" />
          </span>
          <span className="font-serif text-lg font-bold text-navy" data-id="element-182" data-mp="s9q7jpfyirex">IR Nutrition Blueprint™</span>
          <span className="rounded-full border border-gold/40 bg-white px-3 py-1 text-[11px] font-bold uppercase tracking-wide text-navy" data-id="element-183" data-mp="nbf0tnkykx0x">
            By Dr. Henry Wells
          </span>
        </div>

        <p className="mt-6 max-w-xl text-[11px] font-bold uppercase tracking-[0.14em] text-gold-dark sm:text-xs" data-id="element-184" data-mp="380vxpuaomnbk">
          The practical clinical system for structured insulin resistance care
        </p>

        <h1 className="mt-3 font-serif text-[34px] font-extrabold leading-[1.08] text-navy sm:text-5xl md:text-6xl" data-id="element-185" data-mp="3o73p8bldju82">
          Organize the 6 Key Stages of Insulin Resistance Nutrition Care{" "}
          <em className="italic text-gold-dark" data-id="element-186" data-mp="3e7uydrlt2vpx">in Under 15 Minutes</em>
        </h1>

        <p className="mt-5 max-w-2xl text-[17px] leading-relaxed text-muted sm:text-xl" data-id="element-187" data-mp="30h9blrt8e1mr">
          A practical, step-by-step clinical reference system I created to help nutrition professionals organize insulin
          resistance assessments, nutrition consultations, treatment reviews, and follow-up. Includes{" "}
          <strong className="text-ink" data-id="element-188" data-mp="2vjg9payyntsa">6 clinical volumes</strong>, <strong className="text-ink" data-id="element-189" data-mp="2hincgih9yklh">5 professional tools</strong>, and a{" "}
          <strong className="text-ink" data-id="element-190" data-mp="2lkqwhvi0exid">visual clinical decision framework</strong>.
        </p>

        <img src={images.hero} alt="The six volumes and five exclusive tools of Insulin Resistance Nutrition Blueprint™" className="-mx-4 mt-6 w-[calc(100%+2rem)] max-w-none sm:mx-0 sm:w-full sm:max-w-3xl" data-id="element-191" data-mp="s21j2e1koi11" />

        <div className="mt-6 w-full" data-id="element-192" data-mp="id02aln7dwm0">
          <CTAButton id="hero-cta" label="Yes, I want Insulin Resistance Nutrition Blueprint™" note="Instant Download · One-Time Payment of $27 USD · Access to This Edition · 7-Day Money-Back Guarantee" data-id="element-193" data-mp="i9vqb23hxwks" />
        </div>

        <Countdown data-id="element-194" data-mp="163436l90bi9b" />
      </div>
    </header>;
}